import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import FaqForm from './FaqForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import faqService from '../../services/faqService';
import publisherService from '../../services/publisherService';
import faqCategoryService from '../../services/faqCategoryService';

const FaqEdit = (props: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [categories, setCategories] = useState<any[]>([]);

  const [entity, setEntity] = useState<any>({
    id: 0,
    faqCategoryId: '',
    Question: '',
    Answer: '',
  });

  const { checkPermission } = useCheckPermission();

  useEffect(() => {
    faqCategoryService.list().then((response: any) => {
      if (!response.hasError) setCategories(response.records);
      else
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
    });
  }, []);

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    faqService
      .get(params.id)
      .then((response: any) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          setEntity(response.result);
        }
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, [params.id]);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    faqService
      .update(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', {
            variant: 'success',
          });

          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <FaqForm
      entity={entity}
      categories={categories}
      readonly={!checkPermission(['EditFaq'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
    />
  );
};

export default FaqEdit;
